module.exports = __webpack_public_path__ + "img/nav_roster.674ed221.png";